import { useContext } from "react";
import { ModalContext } from "../../Components/Modals";
import ModalAddToCollection, {
  ModalAddToCollectionElementProps,
} from "../../Components/Modals/ModalAddToCollection/modal-add-to-collection";
import ModalCreateCollection, {
  ModalCreateCollectionElementProps,
} from "../../Components/Modals/ModalCreateCollection/modal-create-collection";
import ModalCreateWishlist, { ModalCreateWishlistElementProps } from "../../Components/Modals/ModalCreateWishlist";
import ModalPreviewCollection, {
  ModalPreviewCollectionElementProps,
} from "../../Components/Modals/ModalPreviewCollection";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { CollectionType } from "../../Core/Api/Types/db-collection-type";

const useCollectionActions = () => {
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const CreateNewCollectionModal = (type: CollectionType) => {
    if (!openModal) return;

    const onClose: ModalCreateCollectionElementProps["onClose"] = (data) => {};

    openModal<ModalCreateCollectionElementProps>(ModalCreateCollection, {
      onClose,
      type: type,
    });
  };

  const AddTitleWithSelectToCollection = (collectionId: number) => {
    if (!openModal) return;

    openModal<ModalPreviewCollectionElementProps>(ModalPreviewCollection, { collectionId });
  };

  const AddItemsToCollection = (items: DbAssetObjectInfos[]) => {
    if (!openModal) return;

    const onClose: ModalAddToCollectionElementProps["onClose"] = (data) => {};

    openModal<ModalAddToCollectionElementProps>(ModalAddToCollection, {
      onClose,
      mode: "add",
      itemIds: items.map((item) => item.id),
    });
  };

  const AddItemByIdToCollection = (id: number) => {
    if (!openModal) return;

    const onClose: ModalAddToCollectionElementProps["onClose"] = (data) => {};

    openModal<ModalAddToCollectionElementProps>(ModalAddToCollection, {
      onClose,
      mode: "add",
      itemIds: [id],
    });
  };

  const AddItemsByIdsToCollection = (ids: number[]) => {
    if (!openModal) return;

    const onClose: ModalAddToCollectionElementProps["onClose"] = (data) => {};

    openModal<ModalAddToCollectionElementProps>(ModalAddToCollection, {
      onClose,
      mode: "add",
      itemIds: ids,
    });
  };

  const CreateNewcollectionTypeWishList = (itemIds: number[], back: boolean = false) => {
    if (!openModal) {
      return;
    }

    openModal<ModalCreateWishlistElementProps>(ModalCreateWishlist, {
      itemIds: itemIds,
      back: back,
    });
  };

  return {
    CreateNewCollectionModal,
    AddTitleWithSelectToCollection,
    AddItemsToCollection,
    AddItemByIdToCollection,
    AddItemsByIdsToCollection,
    CreateNewcollectionTypeWishList,
  };
};

export default useCollectionActions;
